import * as gptEncoder from "./Encoder";
export default gptEncoder;
